import React from 'react'

// The sats glyph is a solid lightning bolt. Consumers size and color the svg through
// contextStyles (the existing `svg { width/height; fill/stroke: currentColor }`
// conventions) — the root attributes below are only fallbacks, and a filled bolt stays
// legible at every size in use (10–26px). `showBars` is retired chrome from the old
// circle-S glyph, kept in the signature so call sites don't churn.
export default function SatsIcon({
    showBars: _showBars = true,
    contextStyles,
    inline = false,
}: {
    showBars?: boolean
    contextStyles?: string
    inline?: boolean
}) {
    const Root = inline ? 'span' : 'div'

    return (
        <Root className={contextStyles}>
            <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                stroke="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
        </Root>
    )
}
